import React, { useContext } from 'react';
import { Platform, StyleSheet, ToastAndroid } from 'react-native';
import MaterialIcons from '@react-native-vector-icons/material-icons/static';
import { isTablet } from 'react-native-device-info';
import { ExtrasContext } from '../../../Context/ExtrasContext';
import { useTheme } from '../../../theme';
import { iconSize, v } from '../../../utils/libs';
import HeaderIconButton from './HeaderIconButton';

const isWeb = Platform.OS === 'web';
const tablet = isTablet();
const iconWrapSize = tablet ? 48 : isWeb ? 40 : v(36);
const HEADER_ICON_SIZE = iconSize(tablet ? 32 : 22);

type HeaderInternetStatusIconProps = {
  /** When true, hide while online. Home header: admins only; profile header: owners only. */
  offlineOnly?: boolean;
};

const HeaderInternetStatusIcon: React.FC<HeaderInternetStatusIconProps> = ({
  offlineOnly = false,
}) => {
  const { networkAvailableGlobal } = useContext(ExtrasContext);
  const { theme } = useTheme();

  if (offlineOnly && networkAvailableGlobal) return null;

  const handlePress = () => {
    if (Platform.OS !== 'android') return;
    ToastAndroid.show(
      networkAvailableGlobal
        ? 'You have a stable internet connection'
        : 'You are currently offline. Please check your internet connection and try again.',
      ToastAndroid.SHORT,
    );
  };

  return (
    <HeaderIconButton
      tooltip={
        networkAvailableGlobal ? 'Internet status' : 'No internet connection'
      }
      style={styles.iconWrap}
      onPress={handlePress}
      accessibilityRole="button"
      accessibilityLabel={
        networkAvailableGlobal
          ? 'Check internet status'
          : 'No internet connection'
      }>
      <MaterialIcons
        name={networkAvailableGlobal ? 'wifi' : 'wifi-off'}
        size={HEADER_ICON_SIZE}
        color={networkAvailableGlobal ? '#fff' : theme.colors.textSecondary}
      />
    </HeaderIconButton>
  );
};

const styles = StyleSheet.create({
  iconWrap: {
    width: iconWrapSize,
    height: iconWrapSize,
    borderRadius: iconWrapSize / 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default HeaderInternetStatusIcon;
